import dayjs from "dayjs";
$(() => {
  let sessionTimeOutEnabled = true;
  const $timeoutModal = $("#timeoutModal");
  const timeoutInSeconds = parseInt($timeoutModal.data("session-timeout"), 10);
  const secondsUntilTimeoutPath = $timeoutModal.data("seconds-until-timeout-path");
  const heartbeatPath = $timeoutModal.data("heartbeat-path");
  const interval = parseInt($timeoutModal.data("session-timeout-interval"), 10);
  const preventTimeOutSeconds = $timeoutModal.data("prevent-timeout-seconds");
  let endsAt = dayjs().add(timeoutInSeconds, "seconds");
  let lastAction = dayjs();
  const $continueSessionButton = $("#continueSession");
  let lastActivityCheck = dayjs();
  const activityCheckInterval = 5 * 60;
  const preventTimeOutUntil = dayjs().add(preventTimeOutSeconds, "seconds");
  $continueSessionButton.on("click", () => {
    window.Decidim.currentDialogs.timeoutModal.close();
    $(".reveal-overlay").css("display", "none");
    lastActivityCheck = dayjs();
  });
  if (isNaN(interval)) {
    return;
  }
  if (!timeoutInSeconds) {
    return;
  }
  const disableSessionTimeout = () => {
    sessionTimeOutEnabled = false;
  };
  const enableSessionTimeout = () => {
    sessionTimeOutEnabled = true;
  };
  const setTimer = (secondsUntilExpiration) => {
    if (!secondsUntilExpiration) {
      return;
    }
    endsAt = dayjs().add(secondsUntilExpiration, "seconds");
  };
  const sessionTimeLeft = () => {
    return $.ajax({
      method: "GET",
      url: secondsUntilTimeoutPath,
      contentType: "application/json",
      headers: {
        "X-CSRF-Token": $("meta[name=csrf-token]").attr("content")
      }
    });
  };
  const heartbeat = () => {
    return $.ajax({
      method: "POST",
      url: heartbeatPath,
      contentType: "application/javascript"
    });
  };
  const userBeenActiveSince = (seconds) => {
    return (dayjs() - lastAction) / 1e3 < seconds;
  };
  const exitInterval = setInterval(() => {
    const timeSinceLastActivityCheckInSeconds = Math.round((dayjs() - lastActivityCheck) / 1e3);
    if (!window.Decidim.currentDialogs.timeoutModal.isOpen && timeSinceLastActivityCheckInSeconds >= activityCheckInterval) {
      lastActivityCheck = dayjs();
      if (userBeenActiveSince(activityCheckInterval)) {
        heartbeat();
        return;
      }
    }
    const timeRemaining = Math.round((endsAt - dayjs()) / 1e3);
    if (timeRemaining > 620) {
      return;
    }
    if (dayjs() < preventTimeOutUntil) {
      heartbeat();
      return;
    }
    sessionTimeLeft().then((result) => {
      const secondsUntilSessionExpires = result.seconds_remaining;
      setTimer(secondsUntilSessionExpires);
      if (!sessionTimeOutEnabled) {
        heartbeat();
      } else if (secondsUntilSessionExpires <= 0) {
        $timeoutModal.find("#reveal-hidden-sign-out")[0].click();
      } else if (secondsUntilSessionExpires <= 600) {
        window.Decidim.currentDialogs.timeoutModal.open();
      }
    });
  }, interval);
  $(document).mousemove(() => {
    lastAction = dayjs();
  });
  $(document).scroll(() => {
    lastAction = dayjs();
  });
  $(document).keypress(() => {
    lastAction = dayjs();
  });
  $(document).on("ajax:complete", () => {
    setTimer(timeoutInSeconds);
  });
  $(document).ajaxComplete((_event, _xhr, settings) => {
    if (settings && settings.url === secondsUntilTimeoutPath) {
      return;
    }
    setTimer(timeoutInSeconds);
  });
  window.addEventListener("beforeunload", () => {
    clearInterval(exitInterval);
    return;
  });
  window.Decidim.enableSessionTimeout = enableSessionTimeout;
  window.Decidim.disableSessionTimeout = disableSessionTimeout;
});
